import type { CommandData } from '../types'

export function close() {
  const message: CommandData = {
    isFromBeeetle: true,
    command: 'close',
  }
  window.postMessage(message)
}
